/**
 * Display labels and ordering for reported Issues — shared by the API, the screens and
 * the Copy for Claude Code block, so every surface says the same word.
 *
 * One word for the urgency field everywhere: **Priority**.
 */

import {
  SUPPORT_ISSUE_CATEGORIES,
  SUPPORT_ISSUE_PRIORITIES,
  SUPPORT_ISSUE_STATUSES,
} from "@/db/schema/support-issues";

export type SupportIssueStatus = (typeof SUPPORT_ISSUE_STATUSES)[number];
export type SupportIssuePriority = (typeof SUPPORT_ISSUE_PRIORITIES)[number];
export type SupportIssueCategory = (typeof SUPPORT_ISSUE_CATEGORIES)[number];

export { SUPPORT_ISSUE_CATEGORIES, SUPPORT_ISSUE_PRIORITIES, SUPPORT_ISSUE_STATUSES };

export const STATUS_LABELS: Record<SupportIssueStatus, string> = {
  open: "Open",
  in_progress: "In Progress",
  in_review: "In Review",
  blocked: "Blocked",
  resolved: "Resolved",
  closed: "Closed",
};

export const PRIORITY_LABELS: Record<SupportIssuePriority, string> = {
  low: "Low",
  normal: "Normal",
  high: "High",
  urgent: "Urgent",
};

export const CATEGORY_LABELS: Record<SupportIssueCategory, string> = {
  bug: "Bug",
  question: "Question",
  data: "Data looks wrong",
  feature: "Feature request",
};

/** Resolved and Closed are finished; everything else is still being worked. */
export function isActiveStatus(status: SupportIssueStatus): boolean {
  return status !== "resolved" && status !== "closed";
}

export function isSupportIssueStatus(value: string): value is SupportIssueStatus {
  return SUPPORT_ISSUE_STATUSES.some((s) => s === value);
}

export function isSupportIssuePriority(value: string): value is SupportIssuePriority {
  return SUPPORT_ISSUE_PRIORITIES.some((p) => p === value);
}

export function isSupportIssueCategory(value: string): value is SupportIssueCategory {
  return SUPPORT_ISSUE_CATEGORIES.some((c) => c === value);
}
